import { ConnectedAdmin, FiresideSocketMessages, IBreakoutRoomProfile, SqsSocketTypes } from "../../types/working-model";

export const SIGNATURE_REQUIRED_TYPES = [
	'broadcast-server-ready',
	'broadcast-server-prewarming-fail',
	'broadcast-main-show',
	'broadcast-killed',
	'video-conversion-complete',
	'video-conversion-progress',
	'video-conversion-error',
	'ended_breakouts',
	'bundle_update',
	'bundle_update_sec',
	'session-stream-update',
	'replayVideoUrl',
	'update_chat_message',
	'approve_question',
	'unapprove_question',
	'undelete_question',
	'delete_question',
	'approve_question_comment',
	'unapprove_question_comment',
	'undelete_question_comment',
	'delete_question_comment',
	'update_chat_message',
	'update_question_message',
	'update_question_comment_message',
	FiresideSocketMessages.JOIN_REQ,
	FiresideSocketMessages.JOIN_ACCEPT,
	FiresideSocketMessages.JOIN_DENY,
	SqsSocketTypes.ANNOUNCEMENT,
	SqsSocketTypes.SURVEY,
];

declare global {
	interface Document {
		msHidden: any;
		webkitHidden: any;
	}
}

export interface Listener {
	[key: string]: Array<((...args: any[]) => any)>;
}

export interface SocketMessage {
	type: string;
	data: any;
	message?: any;
	signature?: string;
	moderator_reply?: boolean;
	reactions?: Record<string, number>;
}

export enum MessageTypes {
	getConnection = 'getConnection',
	sendMessage = 'sendMessage',
	getCurrentlyWatching = 'getCurrentlyWatching',
	sendBreakoutData = 'sendBreakoutData',
	updateWorkingEvent = 'updateWorkingEvent',
	disconnect = 'disconnect',
	end = 'end'
}

export enum IncomingTypes {
	message = 'message',
	handleUpdatedUser = 'update-admin',
	handleConnectedAdmin = 'connected-single-admin',
	handleDisconnectedAdmin = 'disconnected-admin',
	handleAdminsConnected = 'connected-admins-list',
	handleUpdatedBRProfile = 'update-breakout-room-profiles',
	handleConnectedBRProfile = 'connected-single-breakout-room-profile',
	handleDisconnectedBRProfile = 'disconnect-profile-from-breakout-room',
	handleBRProfilesConnected = 'connected-breakout-room-profiles-list',
	currentlyWatching = 'currently-watching'
}

export interface IncomingMessage {
	type: IncomingTypes;
	_ns: string;
	admin?: ConnectedAdmin;
	admins?: ConnectedAdmin[];
	blProfile?: IBreakoutRoomProfile;
	blProfiles?: IBreakoutRoomProfile[];
	viewers?: { viewers: string };
	message?: SocketMessage;
}